import React from "react";
import WorkerCard from "./WorkerCard";

export default function StaffPoolPanel({
  workerPool = [],
  searchTerm,
  setSearchTerm,
  staffPoolTab,
  setStaffPoolTab,
  poolFilter,
  showDisabledWorkers,
  setShowDisabledWorkers,
  matchSelectedShiftRole,
  setMatchSelectedShiftRole,
  editWorkerUid,
  setEditWorkerUid,
  expandedWorkerUid,
  setExpandedWorkerUid,
  selectedShiftId,
  availabilityStatusMeta,
  isWorkerAvailabilityBlocked,
  calculateReliabilityScore,
  shiftsActive,
  CredentialBadges,
}) {
  return (
    <>
      <input
        className="input"
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search staff..."
        aria-label="Search staff"
        style={{
          height: 42,
          fontSize: 13,
          borderRadius: 14,
          background: "#f8fafc",
          border: "1px solid #dbe4ee",
        }}
      />

      <div className="schedule-staff-filters"
        style={{
          marginTop: 10,
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 6,
        }}
      >
        {[
          ["ready", "Ready"],
          ["assigned", "Assigned"],
          ["unavailable", "Unavailable"],
          ["all", "All"],
        ].map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setStaffPoolTab(key)}
            aria-pressed={staffPoolTab === key}
            className="btn"
            style={{
              borderRadius: 999,
              fontWeight: 900,
              fontSize: 10,
              padding: "8px 6px",
              background: staffPoolTab === key ? "#2563eb" : "#ffffff",
              color: staffPoolTab === key ? "#ffffff" : "#0f172a",
              border:
                staffPoolTab === key
                  ? "1px solid #2563eb"
                  : "1px solid #dbe4ee",
            }}
          >
            {label}
          </button>
        ))}
      </div>

      <div
        style={{
          marginTop: 8,
          fontSize: 11,
          fontWeight: 800,
          color: "#475569",
        }}
      >
        {poolFilter === "accredited"
          ? `${workerPool.length} ready worker${workerPool.length === 1 ? "" : "s"}`
          : `${workerPool.length} total worker${workerPool.length === 1 ? "" : "s"}`}
      </div>

      <div
        style={{
          marginTop: 10,
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <label style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <input
            type="checkbox"
            checked={showDisabledWorkers}
            onChange={(e) => setShowDisabledWorkers(e.target.checked)}
          />
          <span className="smallMeta" style={{ fontWeight: 800 }}>
            Disabled
          </span>
        </label>

        <label style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <input
            type="checkbox"
            checked={matchSelectedShiftRole}
            onChange={(e) => setMatchSelectedShiftRole(e.target.checked)}
          />
          <span className="smallMeta" style={{ fontWeight: 800 }}>
            Match role
          </span>
        </label>
      </div>

      <div style={{ marginTop: 10, display: "grid", gap: 4 }}>
        {workerPool.map((worker) => {
          const inactive =
            String(worker.status || "active").toLowerCase() === "inactive";

          const availabilityMeta = availabilityStatusMeta(worker);
          const reliabilityScore = calculateReliabilityScore(worker, shiftsActive);

          return (
            <WorkerCard
              key={worker.uid}
              worker={worker}
              inactive={inactive}
              availabilityMeta={availabilityMeta}
              reliabilityScore={reliabilityScore}
              editWorkerUid={editWorkerUid}
              setEditWorkerUid={setEditWorkerUid}
              expandedWorkerUid={expandedWorkerUid}
              setExpandedWorkerUid={setExpandedWorkerUid}
              selectedShiftId={selectedShiftId}
              setMatchSelectedShiftRole={setMatchSelectedShiftRole}
              CredentialBadges={CredentialBadges}
            />
          );
        })}
      </div>
    </>
  );
}